import { wrapGql } from "../_"

export default (a: NuxtAxiosInstance) => ({
  listFaq: ({
    filters,
    sorters,
    limit,
    cfg,
  }: {
    filters?: any,
    sorters?: any,
    limit?: number,
    cfg?: AxiosConfig,
  } = {}) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query (
          $filters: [Filter]
          $sorters: [Sorter]
          $limit: Int
        ) {
          listFAQ (
            filters: $filters
            sorters: $sorters
            limit: $limit
          ) {
            items {
              id
              position
              groups {
                id
                alias
              }
              question {
                current
              }
              answer {
                current
              }
            }
          }
        }
      `,
      variables: {
        filters,
        sorters,
        limit,
      },
    }, cfg),
  ),

  listFAQGroup: () => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          listFAQGroup(limit: 999) {
            items {
              id
              title {
                current
              }
              parent {
                id
              }
            }
          }
        }
      `,
    }),
  ),
})
